// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
// import NutUI from '@nutui/nutui'
import { checkbox,noticebar } from '@nutui/nutui';
import Vue from 'vue'
import Vuex from 'vuex'
import App from './App'
import router from './router/index'
import api from './api/api'
import store from './store/index'
import "mint-ui/lib/style.css"
import {Loadmore} from 'mint-ui'


checkbox.install(Vue);
noticebar.install(Vue);
Vue.prototype.$store = store
Vue.prototype.$http = api
Vue.use(Vuex)
Vue.use(ElementUI)
Vue.component(Loadmore.name,Loadmore)

new Vue({
  el: '#app',
  router,
  store,
  api,
  components: {App},
  template: '<App/>'
})
router.beforeEach((to, from, next) => {
  /* 路由发生变化修改页面title */
  if (to.meta.title) {
    document.title = to.meta.title
  }
  next()
})



// WEBPACK FOOTER //
// ./src/main.js